module.exports = __webpack_public_path__ + "static/assets/6d026568fc8d1c2ccb6bfe7b5623c4ca.svg";